import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SponsoredCard from "./SponsoredCard";

export default function Footer() {
    const { t } = useTranslation();
    return (
        <footer className="border-t border-[var(--np-border)] bg-[var(--np-bg-secondary)] mt-20" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-12 pb-6">
                <SponsoredCard variant="compact" placement="footer" />
            </div>
            <div className="max-w-7xl mx-auto px-5 sm:px-8 pb-12 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div className="md:col-span-1">
                    <div className="flex items-center gap-2 mb-4">
                        <img src="/logo-mark.svg" alt="FileComplain" width="36" height="36" className="h-9 w-9 shrink-0" />
                        <div>
                            <div className="font-serif text-xl font-medium">FileComplain</div>
                            <div className="np-label" style={{ fontSize: "0.6rem" }}>Dispute Resolution, Simplified</div>
                        </div>
                    </div>
                    <p className="text-sm text-[var(--np-text-2)] leading-relaxed max-w-xs">
                        {t("footer.tagline")}
                    </p>
                </div>
                <div>
                    <div className="np-label mb-4">{t("footer.free_tools")}</div>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/tools/legal-notice-generator" className="text-[var(--np-text-2)] hover:text-[var(--np-text)]">{t("nav.legal_notice")}</Link></li>
                        <li><Link to="/tools/complaint-letter-generator" className="text-[var(--np-text-2)] hover:text-[var(--np-text)]">{t("nav.complaint_letter")}</Link></li>
                        <li><Link to="/tools/case-checker" className="text-[var(--np-text-2)] hover:text-[var(--np-text)]">{t("nav.case_checker")}</Link></li>
                        <li><Link to="/tools/compensation-calculator" className="text-[var(--np-text-2)] hover:text-[var(--np-text)]">{t("tools.compensation_title")}</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="np-label mb-4">{t("footer.resources")}</div>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/companies" className="text-[var(--np-text-2)] hover:text-[var(--np-text)]">{t("nav.companies")}</Link></li>
                        <li><Link to="/consumer-forums" className="text-[var(--np-text-2)] hover:text-[var(--np-text)]">{t("nav.forums")}</Link></li>
                        <li><Link to="/blog" className="text-[var(--np-text-2)] hover:text-[var(--np-text)]">{t("nav.guides")}</Link></li>
                        <li><Link to="/faq" className="text-[var(--np-text-2)] hover:text-[var(--np-text)]">FAQs</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="np-label mb-4">FileComplain</div>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/about" className="text-[var(--np-text-2)] hover:text-[var(--np-text)]">{t("footer.about")}</Link></li>
                        <li><Link to="/contact" className="text-[var(--np-text-2)] hover:text-[var(--np-text)]">{t("footer.talk")}</Link></li>
                        <li><Link to="/privacy" className="text-[var(--np-text-2)] hover:text-[var(--np-text)]">{t("footer.privacy")}</Link></li>
                        <li><Link to="/disclaimer" className="text-[var(--np-text-2)] hover:text-[var(--np-text)]">{t("footer.disclaimer")}</Link></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-[var(--np-border)]">
                <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-[var(--np-text-muted)]">
                    <div>© {new Date().getFullYear()} FileComplain. {t("footer.rights")}</div>
                    <div className="flex gap-5">
                        <Link to="/privacy">{t("footer.privacy")}</Link>
                        <Link to="/terms">{t("footer.terms")}</Link>
                        <Link to="/disclaimer">{t("footer.disclaimer")}</Link>
                    </div>
                    <div className="np-label" style={{ fontSize: "0.6rem" }}>{t("footer.legal_note")}</div>
                </div>
            </div>
        </footer>
    );
}
